import type { DisplayType } from '@optionway/models';

export const displayTypeToVariant = (displayType?: DisplayType): 'green' | 'light-blue' | 'orange' => {
  switch (displayType) {
    case 'WARNING': {
      return 'orange';
    }
    case 'INFO': {
      return 'light-blue';
    }
    default: {
      return 'green';
    }
  }
};
